import { useMemo } from "react";

export function useComputePowerAssetsTotal(powerAssets) {
  return useMemo(() => {
    return powerAssets.reduce(
      ([lastTotalProduction, lastTotalAccumulatedRevenue, lastStatusCountObject], powerAsset) => {
        const newStatusCountObject = lastStatusCountObject;

        newStatusCountObject[powerAsset.status] =
          newStatusCountObject[powerAsset.status] === undefined
            ? 1
            : newStatusCountObject[powerAsset.status] + 1;

        return [
          lastTotalProduction + powerAsset.production,
          lastTotalAccumulatedRevenue + powerAsset.acc_revenue,
          newStatusCountObject,
        ];
      },
      [0, 0, {}]
    );
  }, [powerAssets.length]);
}
